import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0d6f6d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-page em-container" }
const _hoisted_2 = { class: "content-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-xag" })
], -1))

import { Ref, ref } from 'vue'
import { v4 as uuidv4 } from 'uuid'
import { commonErrorHandle } from '@/utils/error-handle'
import type { RewardItem, BindingItem, ClaimItem } from '@/types/old-brings-new'
import {
  getBindingsList,
  getRewardList,
  getClaimsList,
  getRecommendCount,
} from '@/apis/old-brings-new'
import Header from '@/components/Header.vue'
import ClaimInvitePerson from './components/claim-invite-person.vue'
import ClaimRewardCard from './components/claim-reward-card.vue'
import ClaimRecordCard from './components/claim-record-card.vue'
import { clearToast, showToastLoading } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'claim-page',
  setup(__props) {

const crrentActiveVal = ref(0)
const recordList: Ref<Array<BindingItem & { uuid: string }>> = ref([])
const rewardList: Ref<RewardItem[]> = ref([])
const claimList: Ref<ClaimItem[]> = ref([])

async function initRecordList() {
  try {
    let data = await getBindingsList()

    recordList.value = data.map((item) => ({
      uuid: uuidv4(),
      ...item,
    }))
    // crrentActiveVal.value = recordList.value.length
  } catch (error) {
    commonErrorHandle(error)
  }
}

async function initRewardList() {
  try {
    const data = await getRewardList()
    rewardList.value = data
  } catch (error) {
    commonErrorHandle(error)
  }
}

async function initClaimList() {
  try {
    const data = await getClaimsList()
    claimList.value = data
  } catch (error) {
    commonErrorHandle(error)
  }
}

async function initCurrentActiveVal() {
  try {
    const data = await getRecommendCount()
    crrentActiveVal.value = data.recommend_count
  } catch (error) {
    commonErrorHandle(error)
  }
}
async function initPageData(onlyClaimList = false) {
  showToastLoading()
  await Promise.all(
    onlyClaimList
      ? [initClaimList()]
      : [initCurrentActiveVal(), initRecordList(), initRewardList(), initClaimList()]
  )
  clearToast()
}

initPageData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { title: "领取进度" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ClaimInvitePerson, { crrentActiveVal: crrentActiveVal.value }, null, 8, ["crrentActiveVal"]),
        _createVNode(ClaimRewardCard, {
          crrentActiveVal: crrentActiveVal.value,
          rewardList: rewardList.value,
          claimList: claimList.value,
          onReceiveSuccess: _cache[0] || (_cache[0] = () => initPageData(true))
        }, null, 8, ["crrentActiveVal", "rewardList", "claimList"]),
        _createVNode(ClaimRecordCard, { recordList: recordList.value }, null, 8, ["recordList"])
      ]),
      _hoisted_3
    ])
  ], 64))
}
}

})